module.exports = __webpack_public_path__ + "static/img/img.046e667c.jpg";